import { useAuth0 } from 'app/Auth'
import axios from 'axios'
import { useMutation } from 'react-query'

interface UnAssignPrefCardParams {
  surgeryId: string
}

interface UnAssignPrefCardResponse {
  message: string
}

export const useUnAssignPreferenceCard = () => {
  const { getAccessToken } = useAuth0()
  const REPORTS_URL = process.env.REACT_APP_REPORTS_URL

  const mutation = useMutation<
    UnAssignPrefCardResponse,
    Error,
    UnAssignPrefCardParams
  >(async (data: UnAssignPrefCardParams) => {
    const token = await getAccessToken()
    try {
      const response = await axios.delete(
        `${REPORTS_URL}api/v1/preference_cards/unassign/${data.surgeryId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      )
      return response.data
    } catch (error) {
      throw error
    }
  })

  return mutation
}
